import * as React from "react"

import { AutocompleteAsyncDebounced } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedBrands } from "../@signals"


/**
 * Brands, NORMALISED — this filters by id_brand, not by the raw string the
 * table shows.
 *
 * That difference is the point. The raw `brand` column is scraper output and is
 * often junk ('', '18477', '8 Funciones'), which is exactly what this screen
 * reports; filtering by it would hide the products whose brand came back empty,
 * which are the ones worth finding.
 */
export default function ScrapingDataReviewBrandsFilter() {
    return <AutocompleteAsyncDebounced
        multiple
        urlAjax={`${BACKEND_APIS.BRANDS}/crud/brand/find-options`}
        label="Brands"
        placeholder="Search Brands..."
        value={selectedBrands.value}
        onChange={e => selectedBrands.value = e.target.value}
        queryParam="search"
    />
}
